import { ReactNode, useCallback, useState } from 'react';
import { NotificationStatus } from '../components/notification/Notification';
import { NotificationContext } from '../contexts/NotificationContext';

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
    const [isNotificationVisible, setIsNotificationVisible] = useState(false);
    const [notificationData, setNotificationData] = useState<{
        title: string;
        description: string;
        status: NotificationStatus;
    }>({ description: '', status: NotificationStatus.info, title: '' });
    const dispatchIsNotificationVisible = useCallback((isVisible: boolean) => {
        setIsNotificationVisible(isVisible);
    }, []);

    const showNotification = useCallback((title: string, description: string, status: NotificationStatus) => {
        setNotificationData({ description, status, title });
        setIsNotificationVisible(true);
    }, []);

    return (
        <NotificationContext.Provider
            value={{
                notificationData,
                showNotification,
                isNotificationVisible,
                setIsNotificationVisible: dispatchIsNotificationVisible,
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};


